import * as amplitude from '@amplitude/analytics-browser';

amplitude.init('1dea85ea19c8e15ecd5ae75941e81754');

// get deviceid form querystring if exists
const urlParams = new URLSearchParams(window.location.search);
const deviceId = urlParams.get('amp_device_id');

if (deviceId) {
    amplitude.setDeviceId(deviceId);
}

export default amplitude;